import { render, staticRenderFns } from "./pcPageV2.vue?vue&type=template&id=ba9fc4e6&scoped=true&"
import script from "./pcPageV2.vue?vue&type=script&lang=js&"
export * from "./pcPageV2.vue?vue&type=script&lang=js&"
import style0 from "./pcPageV2.vue?vue&type=style&index=0&id=ba9fc4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9fc4e6",
  null
  
)

export default component.exports